import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { Link, Outlet } from 'react-router-dom';
import HeaderLayout from './HeaderLayout/HeaderLayout';

const { Content, Sider } = Layout;

/**
 * LayoutStructure component.
 * @component
 * @param {Object} props - The component props.
 * @param {Element} props.StyledLayoutComponent - The styled layout component.
 * @param {Element} props.StyledSiderComponent - The styled sider component.
 * @param {Element} props.LogoDivComponent - The logo div component.
 * @param {Element} props.StyledContentComponent - The styled content component.
 *
 * @returns {JSX.Element} - The LayoutStructure component.
 */
const LayoutStructure = ({
  StyledLayoutComponent,
  StyledSiderComponent,
  LogoDivComponent,
  StyledContentComponent,
  logo,
  logoCollapsed,
  NavMenuComponent,
  collapsed,
  setCollapsed,
  collapseWidth,
  onCollapse,
  siderWidth,
  footerContent,
  headerHeight
}) => (
  <StyledLayoutComponent as={Layout}>
    <StyledSiderComponent
      as={Sider}
      width={256}
      breakpoint="lg"
      trigger={null}
      collapsible
      collapsedWidth={collapseWidth}
      collapsed={collapsed}
      onCollapse={onCollapse}
    >
      <LogoDivComponent>
        <Link to="/">
          <img alt="Logo" src={collapsed ? logoCollapsed : logo} />
        </Link>
      </LogoDivComponent>
      <NavMenuComponent setCollapsed={setCollapsed} />
    </StyledSiderComponent>
    <Layout>
      <HeaderLayout
        collapsed={collapsed}
        collapseSider={setCollapsed}
        collapseWidth={collapseWidth}
        {...(headerHeight !== undefined && { headerHeight })}
        {...(siderWidth !== undefined && { siderWidth })}
      />
      <StyledContentComponent
        as={Content}
        id="mainContent"
        {...(siderWidth !== undefined && { siderWidth })}
      >
        <Outlet />
        {footerContent}
      </StyledContentComponent>
    </Layout>
  </StyledLayoutComponent>
);

LayoutStructure.propTypes = {
  StyledLayoutComponent: PropTypes.elementType.isRequired,
  StyledSiderComponent: PropTypes.elementType.isRequired,
  LogoDivComponent: PropTypes.elementType.isRequired,
  StyledContentComponent: PropTypes.elementType.isRequired,
  logo: PropTypes.string.isRequired,
  logoCollapsed: PropTypes.string.isRequired,
  NavMenuComponent: PropTypes.elementType.isRequired,
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  collapseWidth: PropTypes.number.isRequired,
  onCollapse: PropTypes.func.isRequired,
  siderWidth: PropTypes.number,
  footerContent: PropTypes.node,
  headerHeight: PropTypes.number
};

LayoutStructure.defaultProps = {
  siderWidth: undefined,
  footerContent: null,
  headerHeight: undefined
};

export default LayoutStructure;
